import { render, staticRenderFns } from "./TournamentTrackingModal.vue?vue&type=template&id=46911274"
import script from "./TournamentTrackingModal.vue?vue&type=script&lang=js"
export * from "./TournamentTrackingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports